import { useEffect, useState } from "react";

/* Lightweight, GDPR-friendly cookie/consent banner.
   - Persists choice in localStorage (gr8boost.cookie_consent = "accepted" | "declined")
   - Shows once until cleared. No 3rd-party deps.
   - Declining doesn't disable PostHog (PostHog already runs identified-only), but
     records the user's preference so a future hook can disable it. */
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try {
      const v = localStorage.getItem("gr8boost.cookie_consent");
      if (!v) setVisible(true);
    } catch {
      /* private mode etc — skip */
    }
  }, []);
  const decide = (choice) => {
    try { localStorage.setItem("gr8boost.cookie_consent", choice); } catch { /* noop */ }
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] bg-[#0A0A0A] text-white border border-[#FF4F00] shadow-2xl p-5"
    >
      <div className="text-[10px] uppercase tracking-[0.25em] text-[#FF4F00] font-mono mb-2">Cookies & privacy</div>
      <p className="text-sm leading-relaxed">
        We use a small number of cookies to keep you signed in and to understand how the
        product is used. No data is sold or shared with advertisers.
        See our <a href="/privacy" className="underline">privacy notice</a>.
      </p>
      <div className="mt-4 flex gap-2">
        <button
          onClick={() => decide("accepted")}
          data-testid="cookie-accept"
          className="bg-[#FF4F00] hover:bg-white hover:text-[#0A0A0A] text-white px-4 py-2 text-xs font-semibold uppercase tracking-wider"
        >
          Accept
        </button>
        <button
          onClick={() => decide("declined")}
          data-testid="cookie-decline"
          className="border border-white/40 hover:border-white px-4 py-2 text-xs font-semibold uppercase tracking-wider"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
